import { render, staticRenderFns } from "./knowledgeServiceNav.vue?vue&type=template&id=f0adf65c&scoped=true&"
import script from "./knowledgeServiceNav.vue?vue&type=script&lang=js&"
export * from "./knowledgeServiceNav.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeServiceNav.vue?vue&type=style&index=0&id=f0adf65c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0adf65c",
  null
  
)

export default component.exports